import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/*
 * El mensaje nombra la que falta, no las dos.
 *
 * Decir "faltan X / Y" cuando solo falta una obliga a abrir el bundle
 * compilado para averiguar cual. Paso en produccion y costo dos rondas.
 */
if (!url || !anonKey) {
  const faltan = [!url && 'VITE_SUPABASE_URL', !anonKey && 'VITE_SUPABASE_ANON_KEY'].filter(
    Boolean,
  );
  throw new Error(
    `Falta ${faltan.join(' y ')}. En local va en apps/judge/.env.local; en Cloudflare, ` +
      'en las variables de build del proyecto.',
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // El juez abre la app una vez al inicio del dia y no la vuelve a tocar.
    storageKey: 'timecap.judge.auth',
  },
});
